import { render } from "./syntheseProjet.vue?vue&type=template&id=3fe83071"
import script from "./syntheseProjet.vue?vue&type=script&lang=ts"
export * from "./syntheseProjet.vue?vue&type=script&lang=ts"
script.render = render

export default script